<div [hidden]="!active" class="pane" onchange="onchangeNew()">
  <ng-content></ng-content>
</div>
